class attributs {
    constructor(
     atribId,
     name,
    
    
    ){
        this.atribId = atribId
        this.name = name
      

    
    }
    static fromJson({
        AtribId,
        Nombre,
        
    }){
        return new attributs(
            AtribId,
            Nombre,
            
        )
    }
    }
    export default attributs
    